<ng-container *ngIf="layout === 'drawer'; else pageTpl">
  <app-form-drawer [visible]="!!basicShow" [dismissible]="false" width="min(900px, 100vw)" styleClass="task-form-drawer" (closed)="dialogClose()">
    <ng-container *ngIf="basicShow" [ngTemplateOutlet]="formTpl"></ng-container>
  </app-form-drawer>
</ng-container>

<ng-template #pageTpl>
  <div class="jf-page">
    <ng-container [ngTemplateOutlet]="formTpl"></ng-container>
  </div>
</ng-template>

<ng-template #formTpl>
  <app-form-shell
    [formGroup]="taskForm"
    [title]="title"
    [layout]="layout"
    [loading]="dataLoading"
    [missingFields]="missingFields"
    [canSave]="canSave"
    [saving]="buttonLoading"
    [saveLabel]="editTaskId ? 'Save changes' : 'Add task'"
    (save)="save()"
    (cancel)="dialogClose()">
    <div shellHeader class="jf-head__field tf-head__company" *ngIf="showCompanyField">
      <div class="jf-label"><span>Company <em>*</em></span></div>
      <app-acan-select
        [ngModel]="company"
        [ngModelOptions]="{ standalone: true }"
        [options]="companyNameOptions"
        [disabled]="isCompanyDisabled"
        placeholder="Select company"
        (selectionChange)="onCompanySelect($event)"></app-acan-select>
    </div>

    <div shellHeader class="jf-head__field tf-head__status">
      <div class="jf-label"><span>Status <em>*</em></span></div>
      <app-acan-select
        formControlName="status"
        [options]="statusSelectOptions"
        [itemTemplate]="dotItem"
        placeholder="Status"></app-acan-select>
    </div>

    <app-form-section icon="pi-user" title="Customer">
      <div class="jf-grid">
        <div class="jf-field jf-col-4">
          <div class="jf-label">
            <span>Client</span>
            <i class="pi pi-spin pi-spinner" *ngIf="getClientsLoading && company" aria-label="Loading clients"></i>
          </div>
          <app-acan-select
            formControlName="client"
            [options]="clients"
            [allowAdd]="canAddClient"
            addNewLabel="Add new client"
            [placeholder]="company ? 'Search clients' : 'Select a company first'"
            (addNew)="showDialog($event)"></app-acan-select>
        </div>
        <div class="jf-field jf-col-5">
          <div class="jf-label"><span>Contact person</span></div>
          <app-acan-select
            formControlName="contactPerson"
            [options]="clientContacts"
            [multiple]="true"
            [allowAdd]="!!taskForm.get('client')?.value"
            addNewLabel="Add new contact"
            [placeholder]="taskForm.get('client')?.value ? 'Select contacts' : 'Select a client first'"
            (addNew)="visibleContactForm()"></app-acan-select>
          <p class="jf-hint" *ngIf="taskForm.get('client')?.value && noContacts">
            <i class="pi pi-info-circle"></i> This client has no contacts yet. Use "Add new contact".
          </p>
        </div>
        <div class="jf-field jf-col-3">
          <div class="jf-label">
            <span>Project</span>
            <i class="pi pi-spin pi-spinner" *ngIf="isFetchingProjectData" aria-label="Loading projects"></i>
          </div>
          <app-acan-select
            formControlName="projectName"
            [options]="clientProjectsOption"
            [allowAdd]="setProjectField"
            addNewLabel="Add new project"
            [placeholder]="taskForm.get('client')?.value ? 'Optional' : 'Select a client first'"
            (addNew)="visibleProjectForm()"></app-acan-select>
        </div>
      </div>
    </app-form-section>

    <app-form-section icon="pi-check-square" title="Task details">
      <div class="jf-grid">
        <div class="jf-field jf-col-8">
          <div class="jf-label"><span>Title <em>*</em></span></div>
          <input class="jf-input" type="text" formControlName="title" placeholder="What needs to be done?" />
        </div>
        <div class="jf-field jf-col-4">
          <div class="jf-label"><span>Task type <em>*</em></span></div>
          <app-acan-select
            formControlName="taskType"
            [options]="taskTypes"
            optionLabel="name"
            placeholder="Select task type"></app-acan-select>
        </div>
        <div class="jf-field jf-col-12">
          <div class="jf-label"><span>Description <em>*</em></span></div>
          <textarea class="jf-input jf-textarea" rows="4" formControlName="description" placeholder="Details for the team…"></textarea>
        </div>
      </div>
    </app-form-section>

    <app-form-section icon="pi-calendar" title="Schedule">
      <div class="jf-grid">
        <div class="jf-field jf-col-3">
          <div class="jf-label"><span>Start date <em>*</em></span></div>
          <p-calendar styleClass="jf-cal" formControlName="startDate" dateFormat="dd/mm/yy" [showIcon]="true" [firstDayOfWeek]="1" [readonlyInput]="true" appendTo="body"></p-calendar>
        </div>
        <div class="jf-field jf-col-3">
          <div class="jf-label"><span>Start time</span></div>
          <app-acan-select formControlName="startTime" [options]="timeOptions" placeholder="Start time"></app-acan-select>
        </div>
        <div class="jf-field jf-col-3">
          <div class="jf-label"><span>Due date <em>*</em></span></div>
          <p-calendar styleClass="jf-cal" formControlName="dueDate" dateFormat="dd/mm/yy" [showIcon]="true" [firstDayOfWeek]="1" [readonlyInput]="true" [minDate]="taskForm.get('startDate')?.value" appendTo="body"></p-calendar>
        </div>
        <div class="jf-field jf-col-3">
          <div class="jf-label"><span>End time</span></div>
          <app-acan-select formControlName="endTime" [options]="timeOptions" placeholder="End time"></app-acan-select>
        </div>
        <div class="jf-field jf-col-4">
          <div class="jf-label"><span>Reminder</span></div>
          <app-acan-select
            formControlName="reminder"
            [options]="reminderOptions"
            optionLabel="name"
            placeholder="No reminder"></app-acan-select>
          <p class="jf-hint"><i class="pi pi-mobile"></i> Reminders are sent on the mobile app only.</p>
        </div>
      </div>
    </app-form-section>

    <app-form-section icon="pi-users" title="Team">
      <div class="jf-grid">
        <div class="jf-field jf-col-12">
          <div class="jf-label"><span>Assigned staff</span></div>
          <app-acan-select
            formControlName="staff"
            [options]="staffOptions"
            [multiple]="true"
            [placeholder]="company ? 'Assign staff' : 'Select a company first'"></app-acan-select>
        </div>
      </div>
    </app-form-section>

    <app-form-section icon="pi-paperclip" title="Notes & files">
      <div class="jf-grid">
        <div class="jf-field jf-col-12">
          <div class="jf-label"><span>Attachments</span></div>
          <div class="jf-attachments">
            <p-fileUpload
              #taskUploader
              mode="basic"
              chooseLabel="Attach file"
              chooseIcon="pi pi-paperclip"
              accept=".zip,.pdf,.doc,.docx,.xls,.xlsx,image/*"
              [maxFileSize]="maxFileSize"
              [auto]="true"
              [customUpload]="true"
              [disabled]="isFileUploading"
              (uploadHandler)="onAttachmentUpload($event, taskUploader)"></p-fileUpload>
            <i class="pi pi-spin pi-spinner" *ngIf="isFileUploading" aria-label="Uploading"></i>
            <span class="jf-file" *ngFor="let file of uploadedFiles; let i = index">
              <i class="pi pi-file"></i>
              <a [href]="file.url" target="_blank" rel="noopener">{{ file.originalFileName || 'File' }}</a>
              <button type="button" (click)="renameAttachment(i)" aria-label="Rename attachment"><i class="pi pi-pencil"></i></button>
              <button type="button" (click)="removeFile($event, i)" aria-label="Remove attachment"><i class="pi pi-times"></i></button>
            </span>
          </div>
        </div>
      </div>
    </app-form-section>
  </app-form-shell>
</ng-template>

<ng-template #dotItem let-o>
  <span class="jf-opt"><span class="jf-opt__dot" [style.background]="o.color"></span>{{ o.label }}</span>
</ng-template>

<p-confirmDialog header="Confirmation" key="removeFile" styleClass="jf-dialog" appendTo="body"></p-confirmDialog>

<app-add-edit-client-popup
  *ngIf="BasicShow"
  [basicShow]="BasicShow"
  [defaultCompanyId]="company || null"
  [initialName]="clientPopupName"
  (addClientPopupOnChange)="onAddClientPopupChange($event)">
</app-add-edit-client-popup>

<p-dialog
  header="Rename attachment"
  [(visible)]="renameAttachmentDialog"
  [modal]="true"
  [draggable]="false"
  appendTo="body"
  styleClass="jf-dialog"
  [style]="{ width: '440px' }"
  [breakpoints]="{ '600px': '94vw' }">
  <form [formGroup]="renameAttachmentForm" class="jf-dialog-grid">
    <div class="jf-field jf-dialog-grid__full">
      <div class="jf-label"><span>File name <em>*</em></span></div>
      <div class="tf-rename">
        <input class="jf-input" formControlName="fileName" placeholder="File name" />
        <input class="jf-input tf-rename__ext" formControlName="fileExtension" />
      </div>
      <small class="jf-error" *ngIf="renameAttachmentFormErrors?.fileName?.required">File name is required.</small>
      <small class="jf-error" *ngIf="renameAttachmentFormErrors?.fileName?.error">Don't use "." or "/".</small>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="jf-btn" (click)="renameAttachmentCancel()">Cancel</button>
    <button type="button" class="jf-btn jf-btn--primary" [disabled]="renameAttachmentForm.invalid" (click)="renameAttachmentSave()">Save</button>
  </ng-template>
</p-dialog>

<p-dialog
  header="Add project"
  [(visible)]="isVisibleAddProject"
  (onHide)="closeAddProject()"
  [modal]="true"
  [draggable]="false"
  appendTo="body"
  styleClass="jf-dialog"
  [style]="{ width: '620px' }"
  [breakpoints]="{ '600px': '94vw' }">
  <form [formGroup]="projectForm" class="jf-dialog-grid">
    <div class="jf-field jf-dialog-grid__full">
      <div class="jf-label"><span>Project name <em>*</em></span></div>
      <input class="jf-input" formControlName="name" />
    </div>
    <div class="jf-field jf-dialog-grid__full">
      <div class="jf-label">
        <span>Search address</span>
        <i class="pi pi-spin pi-spinner" *ngIf="dataFetchingToPopupAddress" aria-label="Loading address"></i>
      </div>
      <div class="jf-location">
        <app-search-location-widget [type]="'popup'" (searchLocationDataOnchange)="handleSearchLocationDataChange($event)"></app-search-location-widget>
      </div>
    </div>
    <ng-container formGroupName="address">
      <div class="jf-field">
        <div class="jf-label"><span>Unit</span></div>
        <input class="jf-input" formControlName="unit" />
      </div>
      <div class="jf-field">
        <div class="jf-label"><span>Street</span></div>
        <input class="jf-input" formControlName="street" />
      </div>
      <div class="jf-field">
        <div class="jf-label"><span>Suburb</span></div>
        <input class="jf-input" formControlName="suburb" />
      </div>
      <div class="jf-field">
        <div class="jf-label"><span>State</span></div>
        <input class="jf-input" formControlName="state" />
      </div>
      <div class="jf-field">
        <div class="jf-label"><span>Postcode <em>*</em></span></div>
        <input class="jf-input" formControlName="postalCode" inputmode="numeric" />
        <small class="jf-error" *ngIf="projectFormErrors?.postalCode?.pattern">Numbers only.</small>
      </div>
    </ng-container>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="jf-btn" (click)="closeAddProject()">Cancel</button>
    <button type="button" class="jf-btn jf-btn--primary" [disabled]="projectForm.invalid || updateProjectLoading" (click)="submitProjectData()">
      <i class="pi pi-spin pi-spinner" *ngIf="updateProjectLoading"></i> Add project
    </button>
  </ng-template>
</p-dialog>

<p-dialog
  header="Add contact"
  [(visible)]="isVisibleAddContact"
  [modal]="true"
  [draggable]="false"
  appendTo="body"
  styleClass="jf-dialog"
  [style]="{ width: '560px' }"
  [breakpoints]="{ '600px': '94vw' }">
  <form [formGroup]="contactForm" class="jf-dialog-grid">
    <div class="jf-field">
      <div class="jf-label"><span>First name <em>*</em></span></div>
      <input class="jf-input" formControlName="firstname" />
    </div>
    <div class="jf-field">
      <div class="jf-label"><span>Last name <em>*</em></span></div>
      <input class="jf-input" formControlName="lastname" />
    </div>
    <div class="jf-field">
      <div class="jf-label"><span>Email <em>*</em></span></div>
      <input class="jf-input" type="email" formControlName="email" />
      <small class="jf-error" *ngIf="contactFormErrors?.email?.email">Email is invalid.</small>
    </div>
    <div class="jf-field">
      <div class="jf-label"><span>Mobile <em>*</em></span></div>
      <input class="jf-input" formControlName="mobile" />
      <small class="jf-error" *ngIf="contactFormErrors?.mobile?.pattern">e.g. +61 123456789 or 0123456789</small>
    </div>
    <div class="jf-field">
      <div class="jf-label"><span>Job position</span></div>
      <input class="jf-input" formControlName="jobPosition" />
    </div>
    <div class="jf-field">
      <div class="jf-label"><span>Phone</span></div>
      <input class="jf-input" formControlName="phoneNumber" />
      <small class="jf-error" *ngIf="contactFormErrors?.phoneNumber?.pattern">e.g. +61 123456789 or 0123456789</small>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="jf-btn" (click)="isVisibleAddContact = false">Cancel</button>
    <button type="button" class="jf-btn jf-btn--primary" [disabled]="contactForm.invalid || updateContactLoading" (click)="submitContactData()">
      <i class="pi pi-spin pi-spinner" *ngIf="updateContactLoading"></i> Add contact
    </button>
  </ng-template>
</p-dialog>
